import { reactive } from 'vue';

export const criarGabineteAgenda = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdagenda: 0,
        idgabinete_pessoa: 0,
        assunto: '',
        dtagenda: '',
        hragenda: '',
        detalhamento: '',
        dhconfirmacao: '',
        lgconfirmacao: 0,
        dhchegada: '',
        lgchegada: 0,
        dhcancelamento: '',
        lgcancelamento: 0,
        obscancelamento: '',
        atendimento_dhinicio: '',
        atendimento_dhfim: '',
        atendimento_obs: '',
        idstatus: 0,
        nmstatus: '',
        cdtipo: 1,
        nmtipo: '',
        idlogin: 0,
        idusuario: 0
    });
};